import { MyBookingsHook } from "@models";
import { useStore } from "@stores";

import { useEffect } from "react";

export const useMyUnassignedBookings = (): MyBookingsHook => {
  const { bookingStore } = useStore();
  const {
    myUnassignedBookingsLoading,
    myUnassignedBookings,
    myUnassignedBookingsSkipCount,
    myUnassignedBookingsTotalCount,
    myUnassignedBookingsMaxResultCount,
  } = bookingStore;

  useEffect(() => {
    bookingStore.getMyUnassignedBookings({
      unassigned: true,
      skipCount: myUnassignedBookingsSkipCount,
      maxResultCount: myUnassignedBookingsMaxResultCount,
    });
    return () => {
      if (window.location.pathname === "/my-bookings") return;
      bookingStore.clearMyUnassignedBookings();
      bookingStore.setMyUnassignedBookingsSkipCount(0);
    };
  }, [
    bookingStore,
    myUnassignedBookingsSkipCount,
    myUnassignedBookingsMaxResultCount,
  ]);

  const loadMore = () => {
    bookingStore.setMyUnassignedBookingsSkipCount(
      myUnassignedBookingsSkipCount + myUnassignedBookingsMaxResultCount
    );
  };

  return {
    dataSource: Array.from(myUnassignedBookings.values()),
    loading: myUnassignedBookingsLoading,
    totalCount: myUnassignedBookingsTotalCount,
    maxResultCount: myUnassignedBookingsMaxResultCount,
    loadMore,
  };
};
